/*************************************************/
/* SEARCHBAR                                      /
/*************************************************/

export function searchbar(body) {
    const init = function () {
        const searchBox = document.getElementById('searchBox');
        if (!searchBox) return;
        const searchToggle = document.getElementById('searchToggle');
        const searchInput = searchBox.querySelector('.searchInput');
        const suggestionBox = searchBox.querySelector('.search-suggestions');
        const header = document.querySelector("header");
        const headerLogo = document.querySelector("header__logo");

        searchToggle.addEventListener('click', (e) => {
            e.stopPropagation();

            // If input is not visible yet, just show it and focus
            if (!searchBox.classList.contains('active')) {
                e.preventDefault(); // prevent form submission
                searchBox.classList.add('active');
                header.classList.add("active-search");
                if (headerLogo) {
                    headerLogo.style.display = "none";
                }
                searchInput.focus();
                return;
            }

            // If already open and input has value, let form submit
            if (searchInput.value.trim() === '') {
                e.preventDefault(); // don't submit empty
                searchInput.focus();
                return;
            }

            // Let form submit on second click or Enter if input has text
        });

        // Close search on outside click
        document.addEventListener('click', (e) => {
            if (!searchBox.contains(e.target)) {
                searchBox.classList.remove('active');
                header.classList.remove("active-search");
                if (headerLogo) {
                    headerLogo.style.display = "block";
                }
                // Hide suggestion dropdown as well
                if (suggestionBox) {
                    suggestionBox.style.display = 'none';
                }
            }
        });
    }
    init();
}